<template>
  <div class="container-fluid">
    <div class="accordion" id="idAuswahl">
      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingOne-Auswahl">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne-Auswahl" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne-Auswahl">
            Auswahl
          </button>
        </h2>
        <div class="protokolltyp__rows">
          <div class="protokolltyp__row" v-for="(item,idProtokollTyp) in geraeteProtokollTypen.protokollTypen" v-bind:key="idProtokollTyp">
            <div class="protokolltyp__row--check">              
              <input v-if="!item.isChecked" type="checkbox"  @click="typeClicked(item)" class="protokolltyp__check"/>
              <input v-if="item.isChecked" type="checkbox" checked @click="typeClicked(item)" class="protokolltyp__check"/>
            </div>
            <div class="protokolltyp__row--text">
              {{item.beschreibung}}
            </div>
          </div>
        </div>
        <div id="panelsStayOpen-collapseOne-Auswahl" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne-Auswahl">
          <div class="accordion-body">
            <div class="row">
              <div class="col-7 -test1">
                <!-- Grid für Bereich -->
                <areas />
              </div>
              <div class="col-5 -test1">
                <!-- Grid für Gerät -->
                <devices />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="accordion" id="idAuswertung" data-bs-parent="#idAuswertung">
      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingOne-Auswertung">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne-Auswertung" aria-expanded="false" aria-controls="panelsStayOpen-collapseOne-Auswertung">
            Anzeigen&nbsp;&nbsp;&nbsp;
            <select class="form-select-sm" v-model="selected" @change="getSelectedRecord">
              <option v-for="(item , idCodeverzeichnis) in auswertungen.records" v-bind:key="idCodeverzeichnis">
                {{item.textDe}}
              </option>
            </select>
            <div class="virtual__button">
              Weiter
            </div>
          </button>
        </h2>
        <div id="panelsStayOpen-collapseOne-Auswertung" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingOne-Auswertung" data-bs-parent="#idAuswertung">
          <div class="accordion-body">
            <div class="row">
              <div class="col-12">                
                <DeviceOnlineState v-if="selectedView == 'Online'" />
                <DeviceServiceState v-if="selectedView == 'Service'" v-bind="request" />
                <DeviceAlarmState v-if="selectedView == 'Alarm'" v-bind="request" />
                <MessageHistory v-if="selectedView == 'Sendung'" v-bind="request" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="accordion" id="idEdit" v-if="(selectedView == 'Service' || selectedView == 'Alarm' || selectedView == 'Online') && serviceMethodsCount > 0" data-bs-parent="#idAuswertung" >
      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingOne-Edit">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne-Edit" aria-expanded="false" aria-controls="panelsStayOpen-collapseOne-Edit">
            Versenden
          </button>
        </h2>
        <div id="panelsStayOpen-collapseOne-Edit" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingOne-Edit" data-bs-parent="#idAuswertung">
          <div class="accordion-body">
            <div class="row">
              <div class="col-12">
                <Service v-if="(selectedView == 'Service' || selectedView == 'Alarm' || selectedView == 'Online') && serviceMethodsCount > 0" v-bind="request" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script language="ts">
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import Areas from "@/components/ControlCenter/Areas"
import Devices from "@/components/ControlCenter/Devices"
import DeviceOnlineState from "@/components/ControlCenter/DeviceOnlineState"
import DeviceServiceState from "@/components/ControlCenter/DeviceServiceState"
import Service from "@/components/ControlCenter/Service"
import DeviceAlarmState from "@/components/ControlCenter/DeviceAlarmState"
import { apiPost } from "@/services/api/fetchapi";
import { ProtokollStore } from "@/store/modules/protokollstore";
import MessageHistory  from "@/components/ControlCenter/MessageHistory"

export default {
  name: "ControlCenter",
  inheritAttrs: false,
  components: {
    Areas,
    Devices,
    DeviceOnlineState,
    Service,
    DeviceServiceState,
    DeviceAlarmState,
    MessageHistory    
  },
  setup() {
    const store = useStore();

    const request = reactive({
      MonitoringName: ""
    })

    const protokollStore = new ProtokollStore();

    const geraeteProtokollTypen = reactive({
      protokollTypen: {}
    })

    let auswertungen = reactive({
      records: []
    });
    const serviceMethodsCount = ref(0);
    const selected = ref("");
    const selectedView = ref("")
    let selectedRecord = reactive({ 
      record: {}
    })
    async function getAuswertungen() {
      const response = await apiPost("ComponentView/viewAuswertungen", {
        userId: store.getters["userstore/getUser"]
      });
      auswertungen.records = JSON.parse(JSON.stringify(response));
    }

    async function getProtocolTypes() {
      try {
        const response = await apiPost("ComponentView/viewKomponenteGeraetProtokollTyp", {
            userId: store.getters["userstore/getUser"]
          });
        let temp = [];
        for (let i=0; i<response.length; i++) {
          temp.push(response[i])
        }
        ProtokollStore.setDataSet(store, temp);
        geraeteProtokollTypen.protokollTypen = JSON.parse(JSON.stringify(response));


      } catch (e) {
        console.log("XXX" + e);
      }
    }

    async function getServiceMethods() {
      try {
        const response = await apiPost("ComponentView/viewKomponenteService", {
          MonitoringName: request.MonitoringName
        });
        serviceMethodsCount.value = response.length;
      } catch (e) {
        console.log(e);
      }
    }

    function getSelectedRecord() {
      try {
        selectedRecord.record = auswertungen.records.filter((row) => {
          if( row.textDe == selected.value ) {
            return true;
          }
        })
        selectedView.value = selectedRecord.record[0].sperrcodeListe;
        request.MonitoringName = selected.value;
        getServiceMethods();
      } catch(e) {
        console.log(e);
      }
    }

    getAuswertungen();
    getSelectedRecord();
    getProtocolTypes();

    function typeClicked(protokolltyp) {
      try {        
        let temp = ProtokollStore.getDataSet(store);
        for (let i=0; i < temp.length; i++) {
          if (protokolltyp.idProtokollTyp == temp[i].idProtokollTyp) {
            temp[i].isChecked = !temp[i].isChecked;
            ProtokollStore.setDataSet(store, temp);
            return;
          }
        }
      } catch(e) {
        console.log(e);
      }
    }

 function typeClickedX(protokolltyp) {
      try {
        console.log(protokolltyp.idProtokollTyp)
        let temp = ProtokollStore.getDataSet(store);
        for (let i=0; i < temp.length; i++) {
          if (protokolltyp.idProtokollTyp == temp[i]) {
            temp[i] = temp[i] * 1000;
            ProtokollStore.setDataSet(store, temp);
            return;
          }
        }
        for (let i=0; i < temp.length; i++) {
          if (protokolltyp.idProtokollTyp * 1000 == temp[i]) {
            temp[i] = temp[i] / 1000;
            ProtokollStore.setDataSet(store, temp);
            return;
          }
        }
      } catch(e) {
        console.log(e);
      }
    }

    return {
      auswertungen,
      selected,
      selectedRecord,
      getSelectedRecord,
      selectedView,
      request,
      serviceMethodsCount,
      typeClicked,
      getProtocolTypes,
      geraeteProtokollTypen
    }
  }
};
</script>

<style scoped>
.protokolltyp__rows {
  text-align: left;
  margin-left: 20px;
  
}

.protokolltyp__row {
  font-size: 0.8rem;
  display: inline-block;
  max-height: 2rem;
}

.protokolltyp__row--text {
  display: inline-block;
  min-width: 180px; 
  padding-bottom: 10px;
  margin-left: 6px; 
}
.protokolltyp__row--check {
  min-width: 13px;
  max-width: 13px;
  max-height: 13px;
  display: inline-block;
}

.protokolltyp__check {
  margin-top: 8px;
}

.virtual__button {
  text-align: center;
  padding-top: 3px;
  min-width: 90px; 
  max-width: 90px;
  min-height: 26px;
  max-height: 26px;
  margin-left: 20px;
  border: 2px solid rgb(58, 131, 226);
  border-radius: 6px;
  background-color: white;
}


.AuswertungAuswahl {
  min-height: 40px;
  height: 40px;
}
.panel-heading{    
  padding: 0px !important; 
}
.test1 {
  border: 2px solid lightcoral;
}
.test2 {
  border: 2px solid lightseagreen;
}
.test3 {
  border: 2px solid lightsteelblue;
}
.test4 {
  border: 2px solid lightgoldenrodyellow;
}
.test5 {
  border: 2px solid goldenrod;
}
.test6 {
  border: 2px solid goldenrod;
}
</style>
